import React from 'react';
import s from './TextArea.scss';

const Textarea = ({ variantClasses = [], id, type, value, inputChange, inputBlur = () => { }, isError = false, placeholder = null, label = null, extraAttrs = {} }) => {
  const inputChangeHandlar = (e) => {
    e.preventDefault();
    const $input = e.currentTarget;
    inputChange($input.id, $input.value);
  };

  const inputBlurHandler = (e) => {
    const $input = e.currentTarget;
    inputBlur($input.id, $input.value);
  };

  placeholder = placeholder || null;
  label = label || null;
  
  const inputClasses = [s.input];
  const labelClasses = [s.label];

  if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
  variantClasses.filter((c) => !!c).forEach((c) => {
    if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
    else inputClasses.push(s[c]);
  });

  if (isError !== false) {
    labelClasses.push(s.label__error);
    inputClasses.push(s.input__error);
  }

  const input = <textarea className={inputClasses.join(' ')} id={id} name={id} type={type} value={value || ''} placeholder={placeholder} onChange={inputChangeHandlar} onBlur={inputBlurHandler} {...extraAttrs} />;

  if (label) {
    return (
      <label className={labelClasses.join(' ')} htmlFor={id}>
        <span className={s.input_labelText}>{label}</span>
        {input}
      </label>
    );
  }
  return input;
};

export default Textarea;
